import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useState } from "react";
import PageShell from "../../components/PageShell";
import DoctorsTable from "../team/Doctors/DoctorsTable";
import RolesTable from "../team/Roles/RolesTable";
import DepartmentsTable from "../team/Departments/DepartmentsTable";
import { useAuth } from "../../context/AuthContext";
import { isSuperAdminRole } from "../../utils/roleUtils";
import {
  PAGE_TABS_BAR_SX,
  PAGE_TAB_LIST_PROPS,
  TAB_PANEL_SX,
} from "../../utils/pageLayoutStyles";

const Team = () => {
  const { user } = useAuth();
  const showDepartmentsTab = isSuperAdminRole(user?.roleName);
  const [selectedTab, setSelectedTab] = useState("1");

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <PageShell title="TEAM">
      <TabContext value={selectedTab}>
        <Box sx={PAGE_TABS_BAR_SX}>
          <TabList
            {...PAGE_TAB_LIST_PROPS}
            onChange={handleChange}
          >
            <Tab label="All Doctors" value="1" />
            <Tab label="All Staff" value="2" />
            {showDepartmentsTab && <Tab label="Departments" value="3" />}
          </TabList>
        </Box>
        <TabPanel value="1" sx={TAB_PANEL_SX}>
          <DoctorsTable />
        </TabPanel>
        <TabPanel value="2" sx={TAB_PANEL_SX}>
          <RolesTable />
        </TabPanel>
        {showDepartmentsTab && (
          <TabPanel value="3" sx={TAB_PANEL_SX}>
            <DepartmentsTable />
          </TabPanel>
        )}
      </TabContext>
    </PageShell>
  );
};

export default Team;
